// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import checkoutSharedStyles from "@awc/App/SharedStyles/CheckoutSharedStyles";
import { checkoutShippingCarrierServiceStyles } from "@awc/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCarrierService";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color } from "@awc/XDL/Utilities";
import { css } from "styled-components";

checkoutShippingCarrierServiceStyles.container = {
    gap: 0,
};
checkoutShippingCarrierServiceStyles.innerContainer = {
    gap: 12,
    css: css`
        ${checkoutSharedStyles.sectionInnerContainer?.css}
    `,
};
checkoutShippingCarrierServiceStyles.sectionTitle = {
    ...checkoutSharedStyles.sectionTitle,
};
checkoutShippingCarrierServiceStyles.orderProcessInfo = {
    size: fontConfig.fontSize.regular,
    lineHeight: fontConfig.lineHeight.singleLineRegular,
};
checkoutShippingCarrierServiceStyles.noCarriersFoundText = {
    size: fontConfig.fontSize.regular,
    lineHeight: fontConfig.lineHeight.singleLineRegular,
};
checkoutShippingCarrierServiceStyles.noCarriersFoundGridItem = { width: 12 };
checkoutShippingCarrierServiceStyles.carrierGridItem = { width: 12 };
checkoutShippingCarrierServiceStyles.serviceGridItem = { width: 12 };
checkoutShippingCarrierServiceStyles.deliveryDateGridItem = { width: 12 };
checkoutShippingCarrierServiceStyles.pickUpDateGridItem = { width: 12 };
checkoutShippingCarrierServiceStyles.useShippingAccountGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};
checkoutShippingCarrierServiceStyles.processInfoGridItem = { width: 12 };
checkoutShippingCarrierServiceStyles.shippingVerificationMsg = {
    size: fontConfig.fontSize.regular,
    lineHeight: fontConfig.lineHeight.xSmall,
    css: css`
        margin: 12px 0 6px;
        display: block;
    `,
};
checkoutShippingCarrierServiceStyles.useShippingNumberCheckbox = {
    css: css`
       &&& label {
            color: ${color("text.main")};
            font-size: ${fontConfig.fontSize.small}px;
            line-height: ${fontConfig.lineHeight.singleLineSmall};
        }
    `,
};